import type { IChallenge } from "@bbj-types/challenge";
import type { ISocialOffer } from "@bbj-types/offer";
import { useGlobalContext } from "@root/context";
import { useEffect, useState } from "react";
import { useChallengesByTags } from "../utils";

export const useMenuSelectChallenges = (open: boolean, offer: ISocialOffer) => {
  const { challenges } = useGlobalContext();
  const [selectedChallenges, setSelectedChallenges] = useState<IChallenge[]>([]);
  const challengesOptions = useChallengesByTags(challenges, offer.tags);

  const isSelected = (challenge: IChallenge) => selectedChallenges.some((v) => v._id === challenge._id);

  const handleSelect = (challenge: IChallenge) => {
    if (!isSelected(challenge)) {
      setSelectedChallenges((selectedChallenges) => [...selectedChallenges, challenge]);
    } else {
      setSelectedChallenges((selectedChallenges) => selectedChallenges.filter((v) => v._id !== challenge._id));
    }
  };

  useEffect(() => {
    if (open) {
      setSelectedChallenges([]);
    }
  }, [open]);

  return {
    challengesOptions,
    selectedChallenges,
    setSelectedChallenges,
    handleSelect,
    isSelected,
  };
};
